import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandAlfred(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z"
        fill="#0A0A0A"
      />
      <mask
        style={{ maskType: 'alpha' }}
        id="alfred-a"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="18"
        height="18"
      >
        <path
          d="M16.096 3.6H7.903A4.303 4.303 0 0 0 3.6 7.903v8.194A4.303 4.303 0 0 0 7.903 20.4h8.193a4.303 4.303 0 0 0 4.304-4.303V7.903A4.303 4.303 0 0 0 16.096 3.6Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#alfred-a)">
        <path d="M3.6 3.6h16.8v16.8H3.6V3.6Z" fill="#FFD9AF" />
        <path d="M20.4 20.4v-6.05l-8.307 2.903L3.6 14.357V20.4h16.8Z" fill="#0A0A0A" />
        <g filter="url(#alfred-b)">
          <path d="m3.6 14.35 7.74 1.684-.831 2.417-6.91-4.1Z" fill="#fff" />
        </g>
        <g filter="url(#alfred-c)">
          <path d="m20.4 14.35-7.74 1.684.83 2.417 6.91-4.1Z" fill="#fff" />
        </g>
        <g filter="url(#alfred-d)">
          <path d="m12.253 16.1-.26.94-.277-.94-.834 4.3h2.236l-.865-4.3Z" fill="#FF7200" />
        </g>
        <g filter="url(#alfred-e)">
          <path
            d="M12.905 17.892c-.535.32-1.365.303-1.859 0-.493-.303-.6-1.662-.347-2.033.425-.624 2.37-.528 2.639 0 .199.391.102 1.713-.433 2.033Z"
            fill="#FF7200"
          />
        </g>
        <path
          d="M13.767 11.645c.476 0 .863-.495.863-1.105s-.387-1.106-.863-1.106-.863.495-.863 1.106c0 .61.387 1.105.863 1.105Z"
          fill="#CCAE8C"
        />
        <path
          d="M13.789 11.81c.476 0 .862-.516.862-1.152 0-.636-.386-1.152-.862-1.152-.477 0-.863.516-.863 1.152 0 .636.386 1.152.863 1.152Z"
          fill="url(#alfred-f)"
        />
        <path
          d="M13.619 10.262c.08-.175.076-.35-.01-.39-.086-.04-.221.069-.302.244-.08.175-.076.35.01.39.086.04.221-.07.302-.244Z"
          fill="#fff"
        />
        <path
          d="M10.223 11.645c.481 0 .871-.495.871-1.105s-.39-1.106-.871-1.106-.871.495-.871 1.106c0 .61.39 1.105.87 1.105Z"
          fill="#CCAE8C"
        />
        <path
          d="M10.219 11.81c.481 0 .871-.516.871-1.152 0-.636-.39-1.152-.871-1.152s-.871.516-.871 1.152c0 .636.39 1.152.871 1.152Z"
          fill="url(#alfred-g)"
        />
        <path
          d="M9.98 10.264c.085-.181.084-.36-.003-.4-.086-.04-.224.074-.309.255-.084.181-.083.36.004.4.086.04.224-.074.309-.255Z"
          fill="#fff"
        />
        <path
          d="M9.95 12.891c-.032.03.749.786 2.05.786 1.3 0 2.072-.764 2.048-.786-.024-.021-.622.193-2.049.193-1.426 0-2.017-.222-2.049-.193Z"
          fill="#0A0A0A"
        />
        <path
          d="M3.6 8.541c-3.581-.475 0-4.981 0-4.981h16.8s3.57 4.547 0 5.078c-3.14-.768-3.719-2.136-3.719-2.136-4.768 1.593-9.498 2.514-13.08 2.039Z"
          fill="#2E231C"
        />
        <path
          d="M3.6 8.089c-3.585-.484 0-4.5 0-4.5h16.8s3.296 4.706 0 4.678c-3.176-.748-3.576-2.122-3.576-2.122C12.055 7.626 7.183 8.573 3.6 8.089Z"
          fill="#422A1E"
        />
      </g>
      <defs>
        <filter
          id="alfred-b"
          x="3.216"
          y="13.775"
          width="8.508"
          height="4.867"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-.192" />
          <feGaussianBlur stdDeviation=".192" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4837_2333" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_4837_2333" result="shape" />
        </filter>
        <filter
          id="alfred-c"
          x="12.275"
          y="13.775"
          width="8.508"
          height="4.867"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-.192" />
          <feGaussianBlur stdDeviation=".192" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4837_2333" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_4837_2333" result="shape" />
        </filter>
        <filter
          id="alfred-d"
          x="9.652"
          y="16.1"
          width="3.466"
          height="5.53"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-.615" dy=".615" />
          <feGaussianBlur stdDeviation=".307" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4837_2333" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_4837_2333" result="shape" />
        </filter>
        <filter
          id="alfred-e"
          x="9.287"
          y="14.786"
          width="5.425"
          height="5.258"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy=".639" />
          <feGaussianBlur stdDeviation=".639" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4837_2333" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_4837_2333" result="shape" />
        </filter>
        <linearGradient
          id="alfred-f"
          x1="9.964"
          y1="9.206"
          x2="13.142"
          y2="11.303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="alfred-g"
          x1="6.356"
          y1="9.205"
          x2="9.547"
          y2="11.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
